import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { WHITE, PRIMARY_COLORS } from '../../common/colors';
import whoLogo from '../../assets/WHO-logo.svg';
import loincLogo from '../../assets/Loinc-logo.svg';
import snomedGpsLogo from '../../assets/White.svg';
import cielLogo from '../../assets/ciel-logo-white.svg';

// Webflow section_logo1: dark-brand strip with white partner logos.
const partnerLogos = t => [
  { src: cielLogo, alt: t('home.logo_bar.ciel_alt') },
  { src: whoLogo, alt: t('home.logo_bar.who_alt') },
  { src: loincLogo, alt: t('home.logo_bar.loinc_alt') },
  { src: snomedGpsLogo, alt: t('home.logo_bar.snomed_alt') },
];

const LogoBar = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ backgroundColor: PRIMARY_COLORS['10'] }}>
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h6" component="p" sx={{ color: WHITE, mb: 3 }}>
          {t('home.logo_bar.tagline')}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: { xs: 4, md: 8 } }}>
          {partnerLogos(t).map(logo => (
            <Box key={logo.alt} component="img" src={logo.src} alt={logo.alt} sx={{ height: 44, width: 'auto', maxWidth: 180 }} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default LogoBar;
